// Normalize non-standard ISO timestamps like 2026-08-13T16:01:23:267+0000
// (colon before milliseconds, offset without a colon) into something the JS
// Date parser accepts.
function parseTolerantIso(value: string): Date | null {
  const normalized = value.replace(/:(\d{3})([+-]\d{2})(\d{2})$/, '.$1$2:$3');
  const d = new Date(normalized);
  return isNaN(d.getTime()) ? null : d;
}

export function friendlyTime(iso: string): string {
  const d = parseTolerantIso(iso);
  if (!d) return iso;
  const now = new Date();
  const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === now.toDateString()) return `Today at ${time}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Yesterday at ${time}`;
  return `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })} at ${time}`;
}

// Date-only values (YYYY-MM-DD) must be parsed as local calendar dates, not
// UTC midnight, or they shift a day in negative-offset timezones.
export function friendlyDate(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (match) {
    const d = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (!isNaN(d.getTime())) return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
  }
  const d = parseTolerantIso(value);
  if (!d) return value;
  return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
}
